import { repo } from 'index';
import { useQuery } from '@tanstack/react-query';

export const useEnterpriseTaxSettings = () => {
  const { data, status, isLoading, refetch } = useQuery({
    queryKey: ['tax-settings'],
    queryFn: () => repo.fetchEnterpriseTaxSettings(),
    refetchInterval: false,
  });

  const enterpriseTaxSettings = data?.data?.data ?? [];

  return {
    enterpriseTaxSettings,
    getEnterpriseTaxSettingsStatus: status,
    isGetEnterpriseTaxSettingsLoading: isLoading,
    refetchEnterpriseTaxSettings: refetch,
  };
};
